import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BaseComponent } from 'src/app/shared/components/base.component';
import * as $ from 'jquery';
import { WebStorageService } from '../shared/services/web-storage.service';
import { AutoLogoutService } from '../shared/services/autologout.service';
@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.sass'],
    standalone: false
})
export class AdminComponent extends BaseComponent implements OnInit {
  isActive: boolean = false;
  constructor(private autoLogoutService: AutoLogoutService, private webStorageService: WebStorageService, messageService: MessageService) {
    super(messageService);
  }

  async ngOnInit() {
    this.autoLogoutService.startTracking();
    this.isActive = this.webStorageService.getCurrentMenuStateValue();
  }

  sidebarMenuClick() {
    this.isActive = !this.isActive;
    this.webStorageService.storeCurrentMenuStateValue(this.isActive);
    $('body').toggleClass('sidebarmenu');
  }
}
